// const About = () => import('../components/About')
// const AboutPrivacy = () => import('../components/AboutPrivacy')
// const FollowDoctor = () => import('../components/followDoctor')
// const Login = () => import('../components/Login')
// const Register = () => import('../components/Register')
// const PassReset = () => import('../components/PassReset')
// const FinishInfo = () => import('../components/FinishInfo')
// const UploadInformedConsent = () => import('../components/uploadInformedConsent')
// const Hello = () => import('../components/Hello')
// const Report = () => import('../components/Report')
// const NotFound = () => import('../components/NotFound')
// const FollowupList = () => import('../components/FollowupList')
// const QuestList = () => import('../components/QuestList')
// const QuestItemList = () => import('../components/QuestItemList')

import NotFound from '../components/NotFound'
import FollowupList from '../components/FollowupList'
import QuestList from '../components/QuestList'
import QuestItemList from '../components/QuestItemList'

export default [
  {
    path: '/',
    name: 'home',
    component: FollowupList
  },
  // {
  //   path: '/hello',
  //   name: 'hello',
  //   component: Hello
  // }, {
  //   path: '/finishinfo',
  //   name: 'finishinfo',
  //   component: FinishInfo
  // }, {
  //   path: '/informedconsent',
  //   name: 'informedconsent',
  //   component: UploadInformedConsent
  // }, {
  //   path: '/report',
  //   name: 'report',
  //   component: Report
  // },
  {
    path: '/followuplist',
    name: 'followuplist',
    component: FollowupList
  }, {
    path: '/questlist',
    name: 'questlist',
    component: QuestList
  }, {
    path: '/questitemlist',
    name: 'questitemlist',
    component: QuestItemList
  }, {
    path: '*',
    component: NotFound
  }
]
